import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";
import { tabsPrefixCls } from "@/base/components/index";

const useStyles = createStyles(({ token, css }: any, screens: any) => ({
  tabs: css`
    width: 100%;
    .${tabsPrefixCls}-nav {
      margin: 0;
      padding-inline: ${screens.lg
        ? token.paddingInlineSection
        : token.paddingXSInlineSection};
      justify-content: center;
      .${tabsPrefixCls}-nav-wrap {
        max-width: ${token.maxWidthSection};
      }
    }
  `,
}));

export const useSectionTabsStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
